import Vue from 'vue';
import { services } from '../../Services/Services';
import orderList from '../../Components/order-list.vue';
import orderItemDetailOverlay from '../../Components/order-item-detail-overlay.vue';
import autocomplete from '../../Components/autocomplete.vue';
import mobileNavigationBar from '../../Components/mobile-navigation-bar.vue';
import headerBanner from '../../Components/header-banner.vue';
//import notificationBarCart from '../../Components/notification-bar-cart.vue';
import amzCart from '../../Components/amz-cart.vue';
import basketCount from '../../Components/basket-count.vue';
import shoppingCartService from '../../Services/ShopingCartService';
import VWA from '../../Services/Utils';
import { setInterval, setTimeout } from 'timers';

// load the header banner?
const LOAD_HEADER_BANNER = false;

// import filter from '../../Services/Filters';
require('../../Services/Filters');

// only for the header icon?
//import shoppingCartService from '../../Services/ShopingCartService'
//import basketCount from '../../Components/basket-count.vue';

new Vue({
  el: '#vue-ordering',
  //render: h => h(App),

  data: function () {
    return {
      allergies: {},
      items: {},
      allergyFilterActive: false,
      selectedCategoryId: 0, //selected categoryId
      gridHtml : ''
      // return the shoppingcart model defined in services.js
      //shoppingCart: shoppingCartService.shoppingCart,
    };
	},

  //components: { orderList, amzCart, notificationBarCart, orderItemDetailOverlay },
  components: { orderList, amzCart, mobileNavigationBar, orderItemDetailOverlay, headerBanner },

  mounted: function () {
    var vm = this;

    // category click
    $('#mobile-categories-container .list-group-item').on('carouselclick', processListGroupItemLink);
    $('.col-categories .categories .list-group-item').on('click', processListGroupItemLink);


    //$("#mobile-sub-header .list-group-item").on("click", function (e) {
    //  navState.setNavState(null);
    //  processListGroupItemLink(e);
    //});

    function processListGroupItemLink(event) {

      // wait a bit before closing mobile category menu or other navstate
      //setTimeout(function () {
        navState.setNavState(null);
      //}, 800);
      
      try {
           
        var target = $(event.currentTarget), url = target.attr('href'),
          title = target.attr('title');

        if (!title) {
          title = document.title;
        }
        
      
        // Continue as normal for cmd clicks etc
        // if (event && event.which && (event.which === 2 || event.metaKey)) { return true; }

        // push state
        document.title = title;      
        history.pushState(null, document.title, url);     
        reloadProducts();      
      } catch (ex) {      
        console.log(ex);
      }
      
      event.preventDefault();    
     
      return false;
    }

    var reloadProducts = function () {

      //console.log('reloading');

      let params = VWA.Utils.GetQueryParameters();
      //let categoryId = 2167;/// default category , todo..
      let categoryId = 0;

      // query parameters
      if (params['categoryid']) {
        categoryId = parseInt(params['categoryid']);    // selected categoryId from query parameters
      }

      if (categoryId) {

        vm.selectedCategoryId = categoryId;

        let $link = $('.categories .list-group-item[data-id=' + categoryId + "]");   // corresponing link in category view
        // determine the current active state
        let isActive = !!$link.hasClass('on');
        if (isActive) {
          return;
        }

        // remove all active states from category links
        $('.categories .list-group-item.on').removeClass('on');

        // toggle active state
        isActive = !isActive;
        $link.data('isActive', isActive);

        // set active class on category link
        if (isActive) {
          $link.addClass('on');
        }

        services.getProducts(categoryId, function (data) {
          vm.items = services.filterProducts();
        });

        // trigger an event, for the ui to interact with vue
        $(document).trigger('vue-categorie-changed', $link);
      } else {
        // remove all active states from category links
        $('.categories .list-group-item.on').removeClass('on');
        categoryId = window.pwa_startCategory;
        vm.items = [];
      }

      // get the grid html
      services.getGridHtml(categoryId, function (data) {

        vm.gridHtml = data;
      
        // trigger an event, for the ui to interact with vue
        $(document).trigger('vue-grid-html-load');

        window.setTimeout(function () {
          var video = $('.col-products video.autoplay:visible');
          if (video.length) {
            video.each(function (e) {
              this.load(); this.play();
            });
          }
        }, 500);
       

      });

      if (LOAD_HEADER_BANNER) {
        // load the banner async
        services.setHeaderBanner(categoryId);

      }

      
    };

    // back button.
    window.onpopstate = function (event) {
      reloadProducts();
      //services.UpdateWithAction("#cart-wrapper", false);
    };

    // init, get allergies first, then the products
    services.getAllergies(function (data) {
      vm.allergies = data;
      reloadProducts();
    });
  },

  methods: {

    /**
     * Allergy click hander
     * @param {any} id - the id of the clicked allergy
     */
    onAlergyClick: function (id) {
      // toggle
      this.allergies[id].active = !this.allergies[id].active;

      if (this.allergies[id].active == true) {
        this.allergyFilterActive = true;
      }

      // gather the id's to store
      var ids = [];
      for (var i in this.allergies) {
        if (this.allergies[i].active)
          ids.push(this.allergies[i].Id);
      }
      // store them 
      services.setSelectedAllergies(ids);

      // filter the products based on the selected allergies
      this.items = services.filterProducts();
    },
    resetSelectedAllergies: function () {
      // reset allergy tags to inactive
      for (var i in this.allergies) {
        this.allergies[i].active = false;
      }
      services.setSelectedAllergies({});
      this.items = services.filterProducts();
      this.allergyFilterActive = false;
    }
  },

  computed: {
    activeAllergies: function () {
      var vm = this;
      var result = {};
      for (var i in vm.allergies) {
        if (vm.allergies[i].active)
          result[i] = vm.allergies[i];
      }
      return result;
    },

    showGrid: function () {
      return true;
      //return (this.selectedCategoryId === 0);
    }
  }


});

/**
 * The vue header app
 * Mainly just a wrapper around the search component
 */
new Vue({
  el: '#vue-header',
  //components: { autocomplete, orderItemDetailOverlay, basketCount },
  components: { autocomplete, orderItemDetailOverlay, basketCount },
  data: function () {
    return {
      // return the shoppingcart model defined in services.js
      shoppingCart: shoppingCartService.shoppingCart
    }
  },
});



// WEBPACK FOOTER //
// ./Vue/Src/Areas/Ordering/main.js